import BaseService from './base.service'

export class UserService extends BaseService {
  /**
   * The constructor for the ArtistService.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor (parameters = {}) {
    super('api/user', parameters)
  }
  resetPassword(id, data) {
    return this.submit('post', `/${this.endpoint}/resetpassword/${id}`, data)
  }
  resetCurrentPassword(data) {
    return this.submit('post', `/${this.endpoint}/resetcurrentpassword`, data)
  }
  destroy(id) {
    return this.submit('post', `/${this.endpoint}/inactive/${id}`)
  }
}
